import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { UpgradeModule } from "@angular/upgrade/static";
import { CodemirrorModule } from "@ctrl/ngx-codemirror";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { NgrxFormsModule } from "ngrx-forms";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { OrderModule } from "ngx-order-pipe";
import { DropdownModule } from "primeng/dropdown";
import { SafePipeModule } from "safe-pipe";
import { MessagesModule } from "../messages/messages.module";
import { UserModule } from "../user/user.module";
import { SoundProfileComponent } from "./sound-profile.component";
import { SoundProfileAction } from "./state/sound-profile.action";
import { SoundProfileEffects } from "./state/sound-profile.effects";
import {
  SoundProfileReducer,
  STORE_FEATURE_KEY_SOUND_PROFILE,
} from "./state/sound-profile.reducer";
import { SoundProfileSelectors } from "./state/sound-profile.selectors";
import { SoundProfileService } from "./state/sound-profile.service";
import { SoundUploadModalComponent } from "./sound-upload/sound-upload-modal.component";
import { LanguageSoundsPipe } from "./pipe/language-sounds.pipe";
import { NgxUploaderModule } from "ngx-uploader";
import { TableModule } from "primeng/table";
import { ToKilobytesPipe } from "./pipe/to-kilobytes.pipe";
import { LegacyTagPipe } from "./pipe/legacy-tag.pipe";

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    UpgradeModule,
    FormsModule,
    NgrxFormsModule,
    NgxUploaderModule,
    ReactiveFormsModule,
    TooltipModule,
    SafePipeModule,
    CodemirrorModule,
    MessagesModule,
    NgxIntlTelInputModule,
    BrowserAnimationsModule,
    OrderModule,
    EffectsModule.forFeature([SoundProfileEffects]),
    StoreModule.forFeature(
      STORE_FEATURE_KEY_SOUND_PROFILE,
      SoundProfileReducer
    ),
    DropdownModule,
    UserModule,
    TableModule,
  ],
  declarations: [
    ToKilobytesPipe,
    LanguageSoundsPipe,
    LegacyTagPipe,
    SoundProfileComponent,
    SoundUploadModalComponent,
  ],
  providers: [SoundProfileAction, SoundProfileSelectors, SoundProfileService],
})
export class SoundProfileModule {}
